import { getSelectedCallType, getSelectedCallTypeIDs, toArray } from '../../common/reportingUtils';
import { REPORT_TYPES, DEF_DATE_FORMAT } from '../../../constants';
import format from 'date-fns/format';

/**
 * Forms report parameters object to pass it via props
 * @returns {{
 * aAreas: (Array.String),
 * locations: (Array.String),
 * calltypes: (int[]),
 * timeFrom: (String),
 * timeTo: (String)
 * }}
 */
export function createReportParameters(
    reportData,
    callTypes,
    selectedAANames,
    selectedLocationNames,
    aaForEvent
) {
    let parameters = {};
    let paramsData = {
        reportData: reportData,
        callTypes: callTypes,
        aANames: selectedAANames,
        locationNames: selectedLocationNames,
    };
    switch (reportData.type) {
        case REPORT_TYPES.LOCATION:
            parameters = addParametersLocationReport(paramsData);
            break;
        case REPORT_TYPES.FULL_EVENT:
            parameters = addParametersFullEvent(paramsData);
            break;
        case REPORT_TYPES.ASCOM_EVENT:
            parameters = addParametersAscomEvent(reportData, aaForEvent);
            break;
        case REPORT_TYPES.PAIR_EVENT:
            parameters = addParametersPairEvent(paramsData);
            break;
        case REPORT_TYPES.EXCEPTION:
            parameters = addParametersExceptionReport(paramsData);
            break;
        case REPORT_TYPES.STAFF_PERFORMANCE:
            parameters = addParametersStaffPerformance(paramsData);
            break;
    }

    return parameters;
}

/**
 * Forms time 'from' or 'to' in parameters property
 * @param {string} date
 * @param {string} time
 * @return {string} date_time
 */
export function formTime(date) {
    let timeFormat;
    if (date) {
        timeFormat = format(new Date(parseInt(date)), DEF_DATE_FORMAT);
    }
    return timeFormat;
}

/**
 * Creates report parameters for LocationReport
 * @param {object} paramsData
 * @return {object} parametersLocationReport
 */
export function addParametersLocationReport(paramsData) {
    return {
        aa: paramsData.aANames,
        locations: paramsData.locationNames,
        call_types: getSelectedCallTypeIDs(paramsData.reportData, paramsData.callTypes),
        time_from: formTime(paramsData.reportData.startDate),
        time_to: formTime(paramsData.reportData.endDate),
    };
}

/**
 * Creates report parameters for FullEvent
 * @param {object} paramsData
 * @return {object} parametersFullEvent
 */
export function addParametersFullEvent(paramsData) {
    return {
        aa: paramsData.aANames,
        locations: paramsData.locationNames,
        call_types: getSelectedCallTypeIDs(paramsData.reportData, paramsData.callTypes),
        time_from: formTime(paramsData.reportData.startDate),
        time_to: formTime(paramsData.reportData.endDate),
    };
}

/**
 * Creates report parameters for AscomEvent
 * @param {object} reportData
 * @param {string} aaForEvent
 * @return {object} parametersAscomEvent
 */
export function addParametersAscomEvent(reportData, aaForEvent) {
    return {
        calltrace_id: Number(reportData.calltrace_id),
        aa: toArray(aaForEvent),
        locations: toArray(reportData.event_location),
        call_types: reportData.event_types,
        time_from: formTime(reportData.startDate),
        time_to: formTime(reportData.endDate),
        incomplete: reportData.incomplete,
    };
}

/**
 * Creates report parameters for PairEvent
 * @param {object} paramsData
 * @return {object} parametersPairEvent
 */
export function addParametersPairEvent(paramsData) {
    return {
        aa: paramsData.aANames,
        locations: paramsData.locationNames,
        call_types: getSelectedCallTypeIDs(paramsData.reportData, paramsData.callTypes),
        pair_type: Number(paramsData.reportData.pairEvent),
        time_from: formTime(paramsData.reportData.startDate),
        time_to: formTime(paramsData.reportData.endDate),
    };
}

/**
 * Creates report parameters for ExceptionReport
 * @param {object} paramsData
 * @return {object} parametersExceptionReport
 */
export function addParametersExceptionReport(paramsData) {
    let selectedCallType = getSelectedCallType(paramsData.reportData, paramsData.callTypes);
    return {
        aa: paramsData.aANames,
        locations: paramsData.locationNames,
        call_type: Number(paramsData.reportData.callType),
        time_target_enabled: selectedCallType.time_target_enabled,
        time_target: selectedCallType.target,
        time_delayed: selectedCallType.delayed,
        time_till: selectedCallType.till,
        time_from: formTime(paramsData.reportData.startDate),
        time_to: formTime(paramsData.reportData.endDate),
    };
}

/**
 * Creates report parameters for StaffPerformance
 * @param {object} paramsData
 * @return {object} parametersStaffPerformance
 */
export function addParametersStaffPerformance(paramsData) {
    return {
        aa: paramsData.aANames,
        locations: paramsData.locationNames,
        call_types: getSelectedCallTypeIDs(paramsData.reportData, paramsData.callTypes),
        call_id: paramsData.reportData.call_id,
        call_id_names: paramsData.reportData.call_id_names,
        time_from: formTime(paramsData.reportData.startDate),
        time_to: formTime(paramsData.reportData.endDate),
    };
}
